import React from "react";
import {
  LayoutDashboard,
  Bug,
  FileText,
  Play,
  Code,
  Eye,
  BarChart,
  ArrowLeft,
  Settings,
  PieChart as PieIcon,
  Briefcase,
  FileCheck,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

// This is the component you'll call in your Sidebar UI
export const ProjectBackButton = ({ collapsed = false }) => {
  const navigate = useNavigate();

  return (
    <div className={`${collapsed ? "px-2" : "px-3"} mb-6`}>
      <button
        onClick={() => navigate("/projects")}
        title="Projects"
        aria-label="Projects"
        className={`flex items-center ${collapsed ? "justify-center" : ""} gap-2 text-gray-500 hover:text-purple-500 transition-colors mb-6 text-[25px] font-large font-bold`}
      >
        <ArrowLeft size={18} />
        <Briefcase size={18} />
        <span className={`overflow-hidden whitespace-nowrap transition-[max-width,opacity] duration-200 ${collapsed ? "max-w-0 opacity-0" : "max-w-32 opacity-100"}`}>Projects</span>
      </button>
      {/* <button
        onClick={() => navigate("/projects")}
        className="flex items-center gap-2 text-gray-500 hover:text-purple-500 transition-colors mb-6 text-sm font-medium"
      >
        <ArrowLeft size={18} className="rotate-180" />
        <Briefcase size={18} />
        Back to Optimizer
      </button> */}
    </div>
  );
};

export const SIDEBAR_ITEMS = [
  {
    icon: LayoutDashboard,
    label: "Dashboard",
    key: "Dashboard",
    path: "/dashboard",
  },
  {
    icon: Bug,
    label: "Bug Optimizer",
    key: "Bug Optimizer",
    path: "/bug-optimizer",
  },
  {
    icon: FileText,
    label: "Requirement Mapper",
    key: "Requirement Mapper",
    path: "/requirement-mapper",
  },
  {
    icon: FileCheck,
    label: "Test Cases",
    key: "Test Cases",
    path: "/test-cases",
  },
  {
    icon: Play,
    label: "Test Executor",
    key: "Test Executor",
    path: "/test-executor",
    isComingSoon: false,
  },
  {
    icon: Code,
    label: "API Testing",
    key: "API Testing",
    path: "/apitesting",
  },
  // {
  //   icon: Eye,
  //   label: "Visual Regression",
  //   key: "Visual Regression",
  //   path: "/visual-regression",
  //   isComingSoon: true,
  // },
  {
    icon: BarChart,
    label: "Release Scorer",
    key: "Release Scorer",
    path: "/release-scorer",
  },
  // {
  //   icon: PieIcon,
  //   label: "Reports",
  //   key: "Reports",
  //   path: "/reports",
  //   isComingSoon: true,
  // },
  //{ icon: Settings, label: "Settings", key: "Settings", path: "/settings" },
];

export const NOTIFICATION_TYPES = [
  {
    id: "run",
    title: "Test Run Completions",
    desc: "Get notified when test runs finish",
  },
  {
    id: "bug",
    title: "Bug Assignments",
    desc: "Notifications when bugs are assigned to you",
  },
  {
    id: "release",
    title: "Release Alerts",
    desc: "Updates about release readiness scores",
  },
  {
    id: "digest",
    title: "Daily Digest",
    desc: "Summary of testing activity sent daily",
  },
];
